import * as types from '../mutation-types'
import * as expression from "../../data/base/expressions"
import FateFortuneStore from '../plugins/fatefortune'
import { API } from '../../api'
import { WS } from '../../websocket'
import { DISCUSS_DOM } from '../../dom'
import { SHARE } from '../../share'
import { DISCUSS_DATA_MANAGER, RECORD_DATA_MANAGER } from '../../data'
import { CONST_DISCUSS_MSG_TYPE } from '../../data/base/consts'

export default {
    namespaced: true,
    modules: {
        fatefortune: FateFortuneStore
    },
    state: {
        detailInfo: {},
        gotLunPanList: false,
        lunpanList: [],
        hotLunpanData: false,
        showDiscussSavePop: false,
        showDiscussReportPop: false,
        discussFormData: {},
        hotLunpanList: [],
        hotLunpanTotalData: {},
        secondLunpanTab: 1,
        secondLunpanList: [],
        secondLunpanTotalData: {},
        mySavedLunpanList: [],
        mySavedLunpanTotalData: {},
        myJoinedLunpanList: [],
        myJoinedLunpanTotalData: {},
        isNewLunPan: false,
        hideName: false,
        hasLogined: false,
        curUserUid: 0,
        curMsgType: 1, //消息类型：1文本消息, 2图片, 3语音, 4带有@消息, 5八字, 6撤回, 7回复
        lunpanData: {},
        lunpanSavedList: [],
        lunpanRefreshing: false,
        lunpanGetAll: false,
        lunpanNewestId: 0,
        lunpanHistoryList: [],
        expressionList: [],
        chatImagesList: [],
        showWSFailedPop: false,
        showDiscussEditPop: false,
        showDiscussRecallPop: false,
        showDiscussDownloadPop: false,
        curDiscussQuoteData: {},
        lunpanRoomAllUserOriginalObj: {},
        lunpanRoomAllUserObject: {},
        lunpanRoomAllUserKeys: [],
        lunpanRoomSelectedUserData: [],
        lunpanRoomAtReplyMeList: [],
    },
    mutations: {
        [types.DISCUSS_CHAT_SEND_IMAGE](state, params) {
            console.log('types.DISCUSS_CHAT_SEND_IMAGE------', params, state.lunpanHistoryList);
            state.chatImagesList.push(params.localData);
            state.lunpanHistoryList.push({
                myself: true,
                type: 'image',
                content: params.localData
            });
        },
        [types.DISCUSS_CHAT_GET_WS_MESSAGE](state, data) {
            console.log('types.DISCUSS_CHAT_GET_WS_MESSAGE--------', data)
            // 收到我的消息:替换UI那一条id为-1的消息;
            if(data.userInfo['uid'] && data.userInfo['uid'] == state.curUserUid) {
                if(data.msg_type != CONST_DISCUSS_MSG_TYPE.like && data.msg_type != CONST_DISCUSS_MSG_TYPE.recall) {
                    state.lunpanHistoryList.splice(-1, 1);
                }
            }
            state.lunpanHistoryList = DISCUSS_DATA_MANAGER.addHistoryListDataByData(state.lunpanHistoryList, data, state.lunpanRoomAllUserOriginalObj);
            // 收到消息的时候处理是否有@我的||回复我的
            if(data.msg_type == CONST_DISCUSS_MSG_TYPE.at) {
                var hasAtMe = _.indexOf(DISCUSS_DATA_MANAGER.getAtIdArray(data.content), state.curUserUid);
                if(hasAtMe != -1) {
                    state.lunpanRoomAtReplyMeList.push({
                        f_type: 1,
                        mid: data.id,
                    });
                    AppFate.$bus.emit('checkDiscussBubbleStatus');
                }
            }else if(data.msg_type == CONST_DISCUSS_MSG_TYPE.reply) {
                var tempCont = JSON.parse(data.content),
                    tempData = _.find(state.lunpanHistoryList, data=>{return data.id == tempCont.id});
                if(tempData && tempData.uid == state.curUserUid && data.userInfo.uid != state.curUserUid) {
                    state.lunpanRoomAtReplyMeList.push({
                        f_type: 2,
                        mid: data.id,
                    });
                    AppFate.$bus.emit('checkDiscussBubbleStatus');
                }
            }else if(data.msg_type == CONST_DISCUSS_MSG_TYPE.like) {
                var tempIndex = _.findIndex(state.lunpanHistoryList, oData=>{return oData.id == data.content});
                if(tempIndex != -1) {
                    state.lunpanHistoryList[tempIndex].likeNum = state.lunpanHistoryList[tempIndex].likeNum + 1;
                }
            }
            // AppFate.$bus.emit('scrollToDiscussBottom');
        },
        [types.DISCUSS_CHAT_SEND_MY_WS_MESSAGE](state, data) {
            console.log('types.DISCUSS_CHAT_SEND_MY_WS_MESSAGE--------', data)
            state.lunpanHistoryList = DISCUSS_DATA_MANAGER.addHistoryListDataByMyData(state.lunpanHistoryList, data);
            // 发送的消息是我回复的,就删掉
            if(data.msg_type == CONST_DISCUSS_MSG_TYPE.reply){
                state.curDiscussQuoteData = {};
            }
            AppFate.$bus.emit('scrollToDiscussBottom');
        }
    },
    actions: {
        initHotLunPanList({state}, params) {
            var page = state.hotLunpanTotalData.nowpage ? state.hotLunpanTotalData.nowpage : 0;
            // 刷新dom
            if(parseInt(page) >= parseInt(state.hotLunpanTotalData.totalpage) ||
                (state.hotLunpanTotalData.nowpage && params && !params.update)) {
                if(params && params.cb && typeof(params.cb) == 'function') {
                    params.cb();
                }
                return;
            }
            API.getHotLunPanList({
                page: parseInt(page)+1
            }, function(data) {
                console.log('获取热门论盘列表成功:::::::', data)
                var result = DISCUSS_DATA_MANAGER.getLunPanMainListDataByData(data.info, data.userinfo);
                state.hotLunpanList = state.hotLunpanList.concat(result);
                state.hotLunpanTotalData = data.total;
                
                if(params && params.cb && typeof(params.cb) == 'function') {
                    params.cb();
                }
            })
        },
        initMySavedLunPanList({state}, params) {
            var page = state.mySavedLunpanTotalData.nowpage ? state.mySavedLunpanTotalData.nowpage : 0;
            if(parseInt(page) >= parseInt(state.mySavedLunpanTotalData.totalpage) ||
                (state.mySavedLunpanTotalData.nowpage && params && !params.update)) {
                state.secondLunpanList = state.mySavedLunpanList;
                state.secondLunpanTotalData = state.mySavedLunpanTotalData;
                if(params && params.cb && typeof(params.cb) == 'function') {
                    params.cb();
                }
                return;
            }
            API.getMySavedLunPanList({
                page: parseInt(page)+1
            }, function(data) {
                console.log('获取我保存的论盘列表成功:::::::', data)
                var result = DISCUSS_DATA_MANAGER.getLunPanMainListDataByData(data.info, data.userinfo);
                state.mySavedLunpanList = state.mySavedLunpanList.concat(result);
                state.mySavedLunpanTotalData = data.total;
                state.secondLunpanList = state.mySavedLunpanList;
                state.secondLunpanTotalData = state.mySavedLunpanTotalData;
                if(params && params.cb && typeof(params.cb) == 'function') {
                    params.cb();
                }
            })
        },
        initMyJoinedLunPanList({state}, params) {
            var page = state.myJoinedLunpanTotalData.nowpage ? state.myJoinedLunpanTotalData.nowpage : 0;
            if(parseInt(page) >= parseInt(state.myJoinedLunpanTotalData.totalpage) ||
                (state.myJoinedLunpanTotalData.nowpage && params && !params.update)) {
                state.secondLunpanList = state.myJoinedLunpanList;
                state.secondLunpanTotalData = state.myJoinedLunpanTotalData;
                if(params && params.cb && typeof(params.cb) == 'function') {
                    params.cb();
                }
                return;
            }
            API.getMyJoinedLunPanList({
                page: parseInt(page)+1
            }, function(data) {
                console.log('获取我参与的论盘列表成功:::::::', data)
                var result = DISCUSS_DATA_MANAGER.getLunPanMainListDataByData(data.info, data.userinfo);
                state.myJoinedLunpanList = state.myJoinedLunpanList.concat(result);
                state.myJoinedLunpanTotalData = data.total;
                state.secondLunpanList = state.myJoinedLunpanList;
                state.secondLunpanTotalData = state.myJoinedLunpanTotalData;
                if(params && params.cb && typeof(params.cb) == 'function') {
                    params.cb();
                }
            })
        },
        initLunPanList({state}, detailData) {
            state.detailInfo = detailData;
            if(state.gotLunPanList) { return; }

            API.getLunPanList({
                hid: detailData.id
            }, function(data){
                state.gotLunPanList = true;
                if(data.length == 0) { return; }
                console.log('获取论盘列表成功::::::', data);
                var newList = [];
                data.forEach(dd => {
                    var lunpanData = DISCUSS_DATA_MANAGER.getLunPanDataByData(dd);
                    newList.push(lunpanData);
                });
                state.lunpanList = newList
                AppFate.$store.state.detail.baziNumData.lunpan = state.lunpanList.length;
            });
        },
        addNewLunPan({dispatch, state}, params) {
            var newParams = {
                hid: state.detailInfo.id,
                f_title: params.params.lunpanName,
                share_all: params.params.public ? 1 : 0,
                hidename: params.params.anony ? 1 : 0
            };
            newParams = params.params.lunpanDes != '' ? Object.assign(newParams, {f_des: params.params.lunpanDes}) : newParams;
            console.log('addNewLunPan-------', state.detailInfo.id, newParams)
            API.addLunPan(newParams, function(data){
                // Todo here 引导分享微信or朋友圈邀请好友一起来论盘
                console.log('新增论盘成功::::::', data);

                state.isNewLunPan = true;
                // 更新列表数据的论盘状态
                dispatch('record/updateRecordListLunpanStatus', state.detailInfo.id, {root: true})
                dispatch('detail/updateDetailLunpanStatus', null, {root: true})
                var lunpanData = DISCUSS_DATA_MANAGER.getLunPanDataByData(data);
                state.lunpanList.push(lunpanData);
                AppFate.$store.state.detail.baziNumData.lunpan = state.lunpanList.length;
                if(params.cb && typeof(params.cb) == 'function') {
                    params.cb(lunpanData);
                }
            });
        },
        editLunPanData({commit, state}, params) {
            var newParams = _.omit(params, ['cb']);
            API.updateLunPan(newParams, function(data){
                if(data.ret){
                    console.log('修改论盘成功::::::', data)
                    state.lunpanList = DISCUSS_DATA_MANAGER.updateLunPanListDataTitle(state.lunpanList, params);
                    if(params.cb && typeof(params.cb) == 'function') {
                        setTimeout(() => {
                            params.cb();
                        }, 20);
                    }
                }
            });
        },
        deleteLunPanData({commit, state}, deleteId) {
            console.log('deleteLunPanData------', deleteId)
            API.deleteLunPan({
                id: deleteId
            }, function(data){
                if(data.ret) {
                    console.log('删除论盘成功::::::', data)
                    state.lunpanList = DISCUSS_DATA_MANAGER.deleteLunPanListData(state.lunpanList, deleteId);
                    state.hotLunpanList = DISCUSS_DATA_MANAGER.deleteLunPanListData(state.hotLunpanList, deleteId);
                    state.secondLunpanList = DISCUSS_DATA_MANAGER.deleteLunPanListData(state.secondLunpanList, deleteId);
                    AppFate.$store.state.detail.baziNumData.lunpan = state.lunpanList.length;
                }
            })
        },
        initLunPan({commit, state}, params) {
            // 拉取论盘聊天记录列表数据，并初始化websockt实时聊天
            console.log('initLunPan-----', state.lunpanHistoryList, params)
            state.lunpanData = params.lunpanData;
            state.lunpanHistoryList = [];

            // 获取论盘的保存状态
            let shareCode = params.lunpanData.share ? params.lunpanData.share : '';
                shareCode = params.lunpanData.shareCode ? params.lunpanData.shareCode.smlpshare : shareCode;
            API.getOtherShareData({
                code: shareCode
            }, function(data) {
                state.lunpanSavedList = data.list;
                console.log("getOtherShareData------", shareCode, data, state.lunpanSavedList);
            });

            // 获取论盘消息记录列表
            API.getLunPanMsgList({
                rid: params.lunpanData.rid
            }, function(data){
                console.log('获取论盘消息记录列表成功::::::', data)

                state.hasLogined = true;
                if(data.length > 0) {
                    var resultData = DISCUSS_DATA_MANAGER.initHistoryListDataByList(state.lunpanHistoryList, data, state.lunpanRoomAllUserOriginalObj);
                    state.lunpanHistoryList = resultData.resultList;
                    state.lunpanNewestId = resultData.newestId;
                }
                if(params.cb && typeof(params.cb) == 'function') {
                    params.cb();
                }
            })
            state.expressionList = expression.CONST_EXPRESSION;
        },
        initShareLunPan({dispatch, state}, params) {
            state.detailInfo = params.detailData;
            // 暂存命盘数据
            AppFate.$store.state.detail.personInfo = params.detailData;
            AppFate.$store.dispatch('detail/initDetail', params.detailData);
            AppFate.$store.dispatch('minifatefortune/initCommentMiniFateFortune', params.detailData);
            state.lunpanData = DISCUSS_DATA_MANAGER.getLunPanDataByData(params.lunpanData);
            state.lunpanSavedList = params.listData ? params.listData : [];
            state.lunpanHistoryList = [];
            // console.error('-------', state.lunpanData)

            // 初始化IM
            WS.initWebSocket(params.lunpanData.rid, function(){
                // 拉取论盘聊天记录列表数据，并初始化websockt实时聊天
                console.log('initShareLunPan-----', state.lunpanHistoryList, params)
                API.getLunPanMsgList({
                    rid: params.lunpanData.rid
                }, function(data){
                    console.log('获取论盘消息记录列表成功::::::', data)
                    state.hasLogined = true;
                    if(data.length > 0) {
                        var resultData = DISCUSS_DATA_MANAGER.initHistoryListDataByList(state.lunpanHistoryList, data, state.lunpanRoomAllUserOriginalObj);
                        state.lunpanHistoryList = resultData.resultList;
                        state.lunpanNewestId = resultData.newestId;
                        setTimeout(() => {
                            AppFate.$bus.emit('initDiscussHistoryList');
                            DISCUSS_DOM.updateDiscussPageStyle();
                            DISCUSS_DOM.updateDiscussFormStyle();
                        }, 300);
                        setTimeout(() => {
                            AppFate.$bus.emit('scrollToDiscussBottom');
                            AppFate.$bus.emit('checkDiscussBubbleStatus');
                        }, 1000);
                    }
                    dispatch('initLunPanRoomConfig', {id: state.lunpanData.rid})
                })
                state.expressionList = expression.CONST_EXPRESSION;
            }, function(){
                state.showWSFailedPop = true;
            });

            // 设置微信分享配置
            var fromEmbedded = AppFate.$store.state.embedded.fromEmbedded;
            setTimeout(() => {
                if(!fromEmbedded){
                    SHARE.initConfigShare();
                }
            }, 1000);
        },
        refreshHistoryMsgList({state}) {
            // console.log('refreshHistoryMsgList-------', state.lunpanData, state.lunpanNewestId);
            // 如果是新论盘，不刷新:::Todo 方案可优化
            if(state.isNewLunPan) {
                state.isNewLunPan = false;
                state.lunpanRefreshing = false;
                state.lunpanGetAll = true;
                return;
            }
            API.getLunPanMsgList({
                rid: state.lunpanData.rid,
                id: state.lunpanNewestId
            }, function(data){
                console.log('刷新论盘消息记录列表成功:::::::', data)
                state.lunpanRefreshing = false;
                if(data.length > 0) {
                    var resultData = DISCUSS_DATA_MANAGER.initHistoryListDataByList(state.lunpanHistoryList, data, state.lunpanRoomAllUserOriginalObj);
                    state.lunpanHistoryList = resultData.resultList;
                    state.lunpanNewestId = resultData.newestId < state.lunpanNewestId ? resultData.newestId : state.lunpanNewestId;
                    setTimeout(() => {
                        DISCUSS_DOM.updateDiscussPageStyle();
                        DISCUSS_DOM.updateDiscussFormStyle();
                    }, 300);
                }else if(data.length == 0) {
                    console.log('state.lunpanGetAllstate.lunpanGetAll', state.lunpanGetAll)
                    state.lunpanGetAll = true;
                }
            })
        },
        getWSLogin({state}, data) {
            state.curUserUid = data && data.userInfo ? data.userInfo.uid : 0;
        },
        getWSMessage({commit}, data) {
            commit(types.DISCUSS_CHAT_GET_WS_MESSAGE, data);
        },
        sendMyWSMessage({commit}, data) {
            commit(types.DISCUSS_CHAT_SEND_MY_WS_MESSAGE, data);
        },
        chatSendImage({commit}, params) {
            commit(types.DISCUSS_CHAT_SEND_IMAGE, params);
        },
        recallMyWSMessage({state}, data) {
            state.lunpanHistoryList.splice(data.index, 1);
            state.lunpanHistoryList = DISCUSS_DATA_MANAGER.addHistoryListDataByMyData(state.lunpanHistoryList, data);
            AppFate.$bus.emit('scrollToDiscussBottom');
            // 服务端发送数据
            WS.sendMessageWS({
                msg_type: data.msg_type,
                content: data.content
            });
        },
        replyWSMessage({state}, data) {
            // 回复消息
            state.lunpanHistoryList = DISCUSS_DATA_MANAGER.addHistoryListDataByMyData(state.lunpanHistoryList, data);
            AppFate.$bus.emit('scrollToDiscussBottom');
        },
        likeWSMessage({state}, data) {
            // 点赞消息
            console.error('likeWSMessage-------', data);
            // state.lunpanHistoryList = DISCUSS_DATA_MANAGER.addHistoryListDataByMyData(state.lunpanHistoryList, data);
            AppFate.$bus.emit('scrollToDiscussBottom');
            // 服务端发送数据
            WS.sendMessageWS({
                msg_type: data.msg_type,
                content: data.content
            });
        },
        initLunPanRoomConfig({state}, params) {
            if(state.gotLunPanRoomConfig) {
                return;
            }
            // 初始化房间内的所有人
            API.getLunPanRoomConfig({
                rid: params.id
            }, function(data) {
                // 所有房间内的人列表
                state.lunpanRoomAllUserOriginalObj = data.allUser;
                state.lunpanRoomAllUserObject = DISCUSS_DATA_MANAGER.getLunPanAllUserObjectByData(data.allUser, state.curUserUid, state.lunpanRoomSelectedUserData);
                state.lunpanRoomAllUserKeys = _.keysIn(state.lunpanRoomAllUserObject);
                // @我的和回复我的人列表
                state.lunpanRoomAtReplyMeList = data.touchMe;
                console.log('获取参与论盘人员信息成功:::::::', data, state.lunpanRoomAllUserObject);
            });
        },
        toggleLunPanRoomAllUserObjectSelected({state}, itemData) {
            state.lunpanRoomAllUserObject = DISCUSS_DATA_MANAGER.updateLunPanAllUserObject(state.lunpanRoomAllUserObject, itemData);
            var sIndex = _.findIndex(state.lunpanRoomSelectedUserData, data=>{return data.uid == itemData.uid});
            if(itemData.selected) {
                state.lunpanRoomSelectedUserData.push(itemData);
            }else {
                state.lunpanRoomSelectedUserData.splice(sIndex, 1);
            }
            console.error('更新数据-------', itemData, state.lunpanRoomSelectedUserData)
        },
        searchLunpanRoomAllUserObject({state}, text) {
            var filterObject = _.pickBy(state.lunpanRoomAllUserOriginalObj, data=>{
                return data.nickname.indexOf(text) != -1;
            });
            
            console.error('searchLunpanRoomAllUserObject------', text, filterObject, state.lunpanRoomAllUserOriginalObj)
            if(filterObject) {
                state.lunpanRoomAllUserObject = DISCUSS_DATA_MANAGER.getLunPanAllUserObjectByData(filterObject, state.curUserUid, state.lunpanRoomSelectedUserData);
                state.lunpanRoomAllUserKeys = _.keysIn(state.lunpanRoomAllUserObject);
            }else {
                state.lunpanRoomAllUserObject = {};
                state.lunpanRoomAllUserKeys = [];
            }
        },
        resetLunpanRoomAllUserObject({state}) {
            state.lunpanRoomAllUserObject = DISCUSS_DATA_MANAGER.getLunPanAllUserObjectByData(state.lunpanRoomAllUserOriginalObj, state.curUserUid, state.lunpanRoomSelectedUserData);
            state.lunpanRoomAllUserKeys = _.keysIn(state.lunpanRoomAllUserObject);
        },
        setLunpanRoomAtMeReaded({state}, params) {
            if(params && params.params) {
                API.setLunPanAtMeRead(params.params, function(data) {
                    if(data.ret) {
                        console.log('成功设置@我的消息已读:::::::::', data)
                        state.lunpanRoomAtReplyMeList.splice(0, 1);
                        if(params && params.cb && typeof(params.cb) == 'function') {
                            params.cb();
                        }
                    }
                })
            }
        },
        initDiscussSavePop({state}) {
            state.showDiscussSavePop = true;
            state.discussFormData = {
                f_name: state.lunpanData.bz ? state.lunpanData.bz.f_name : '未命名',
                group: '', groupId: 0,
                shareTitle: state.lunpanData.title,
            }
        },
        saveNewPaipanLunpan({dispatch, state}, params) {
            state.showDiscussSavePop = false;
            let bzData = state.lunpanData.bz ? state.lunpanData.bz : AppFate.$store.state.detail.personInfo;
            var formData = Object.assign(bzData, {
                f_group: state.discussFormData.groupId
            });
            formData.f_name = state.discussFormData.f_name;
            console.log('saveNewPaipanLunpan----', bzData, formData)

            API.addPaiPan(formData, function(data) {
                console.log('保存命盘成功-----', data)
                state.detailInfo = data;
                // 更新列表数据
                AppFate.$store.dispatch('record/updateRecordListData', data);
                // 更新分组数据
                var groupData = AppFate.$store.state.group.groupData;
                var recordData = RECORD_DATA_MANAGER.getRecordDataByData(data, groupData);
                AppFate.$store.dispatch('group/updateGroupListData', recordData);
                // 处理过滤列表数据
                AppFate.$store.dispatch('record/updateRecordFilterList');
                
                API.addLunPan({
                    hid: data.id,
                    rid: state.lunpanData.rid,
                    f_title: state.discussFormData.shareTitle
                }, function(retData){
                    console.log('保存论盘成功-----', retData)
                    // 更新列表数据的论盘状态
                    dispatch('record/updateRecordListLunpanStatus', data.id, {root: true})
                    dispatch('detail/updateDetailLunpanStatus', null, {root: true});
                    
                    state.hotLunpanData = false;
                    state.lunpanData = data;
                    dispatch('discuss/initShareLunPan', {
                        detailData: data,
                        lunpanData: retData
                    }, { root: true });

                    setTimeout(() => {
                        if(params && params.cb && typeof(params.cb) == 'function') {
                            params.cb(data);
                        }
                    }, 100);
                })
            })
            // console.log('saveNewPaipanLunpan-------', formData)
        },
        initDiscussReportPop({state}) {
            state.showDiscussReportPop = true;
            state.discussFormData = {
                f_name: state.lunpanData.bz ? state.lunpanData.bz.f_name : '未命名',
                group: '', groupId: 0,
            }
        },
        saveNewPaipanToReport({state}, params) {
            state.showDiscussReportPop = false;
            let bzData = state.lunpanData.bz ? state.lunpanData.bz : AppFate.$store.state.detail.personInfo;
            var formData = Object.assign(bzData, {
                f_group: state.discussFormData.groupId
            });
            formData.f_name = state.discussFormData.f_name;
            console.log('saveNewPaipanToReport-----', bzData, formData);

            API.addPaiPan(formData, function(data) {
                console.log('保存命盘成功-----', data)
                state.detailInfo = data;
                state.lunpanSavedList = [data];
                // 更新列表数据
                AppFate.$store.dispatch('record/updateRecordListData', data);
                // 更新分组数据
                var groupData = AppFate.$store.state.group.groupData;
                var recordData = RECORD_DATA_MANAGER.getRecordDataByData(data, groupData);
                AppFate.$store.dispatch('group/updateGroupListData', recordData);
                // 处理过滤列表数据
                AppFate.$store.dispatch('record/updateRecordFilterList');

                // 获取测算报告并处理回调
                AppFate.$store.state.detail.personInfo = data;
                AppFate.$store.dispatch('report/initReportAIConfig', {
                    cb: function() {
                        AppFate.$store.dispatch('report/getReportInfo', {
                            detailInfo: data,
                            cb: function() {
                                if(params && params.cb && typeof(params.cb) == 'function') {
                                    params.cb(data);
                                }
                            }
                        });
                    }
                });
            })
        },
        goDiscussToReport({state}, params) {
            // 获取测算报告并处理回调
            AppFate.$store.state.detail.personInfo = params.data;
            AppFate.$store.dispatch('report/initReportAIConfig', {
                cb: function() {
                    AppFate.$store.dispatch('report/getReportInfo', {
                        detailInfo: params.data,
                        cb: function() {
                            if(params && params.cb && typeof(params.cb) == 'function') {
                                params.cb();
                            }
                        }
                    });
                }
            });
        },
        resetData({state}) {
            state.detailInfo = {};
            state.gotLunPanList = false;
            state.lunpanList = [];
            state.hotLunpanData = false;
            state.showDiscussSavePop = false;
            state.showDiscussReportPop = false;
            state.discussFormData = {};
            state.hotLunpanList = [];
            state.hotLunpanTotalData = {};
            state.secondLunpanTab = 1;
            state.secondLunpanList = [];
            state.secondLunpanTotalData = {};
            state.mySavedLunpanList = [];
            state.mySavedLunpanTotalData = {};
            state.myJoinedLunpanList = [];
            state.myJoinedLunpanTotalData = {};
            state.isNewLunPan = false;
            state.hideName = false;
            state.hasLogined = false;
            state.curUserUid = 0;
            state.curMsgType = CONST_DISCUSS_MSG_TYPE.text;
            state.lunpanData = {};
            state.lunpanRefreshing = false;
            state.lunpanGetAll = false;
            state.lunpanNewestId = 0;
            state.lunpanHistoryList = [];
            state.expressionList = [];
            state.chatImagesList = [];
            state.showWSFailedPop = false;
            state.showDiscussEditPop = false;
            state.showDiscussRecallPop = false;
            state.showDiscussDownloadPop = false;
            state.curDiscussQuoteData = {};
            state.lunpanRoomAllUserOriginalObj = {};
            state.lunpanRoomAllUserObject = {};
            state.lunpanRoomAllUserKeys = [];
            state.lunpanRoomSelectedUserData = [];
            state.lunpanRoomAtReplyMeList = [];
        },
        resetLunPanData({state}) {
            state.isNewLunPan = false;
            state.hideName = false;
            state.hasLogined = false;
            state.curUserUid = 0;
            state.curMsgType = CONST_DISCUSS_MSG_TYPE.text;
            state.lunpanData = {};
            state.lunpanSavedList = [];
            state.lunpanRefreshing = false;
            state.lunpanGetAll = false;
            state.lunpanNewestId = 0;
            state.lunpanHistoryList = [];
            state.expressionList = [];
            state.chatImagesList = [];
            state.showWSFailedPop = false;
            state.showDiscussEditPop = false;
            state.showDiscussRecallPop = false;
            state.showDiscussDownloadPop = false;
            state.curDiscussQuoteData = {};
            state.lunpanRoomAllUserOriginalObj = {};
            state.lunpanRoomAllUserObject = {};
            state.lunpanRoomAllUserKeys = [];
            state.lunpanRoomSelectedUserData = [];
            state.lunpanRoomAtReplyMeList = [];
        }
    }
}
